import { z } from 'zod';
import { BaseFacilityDTOSchema, } from "./facilities.dto.js";
// Request and response schemas for the API layer
export const FindFacilitiesByCompanyIdRequestDTOSchema = z.object({
    params: z.object({
        companyId: BaseFacilityDTOSchema.shape.companyId,
    }),
});
//# sourceMappingURL=find-facilities-by-company-id.dto.js.map